import { ReactSVG } from "react-svg";
import { ContactEmailRow } from "services/api/contacts/types";
import Badge from "ui/components/Badge/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Stupci emailova u čarobnjaku kontakta — isti izgled kao popis PP aparata na unosu vozila. */
export const CONTACT_EDIT_EMAIL_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactEmailRow) => {
      return (
        <div className="flex items-center gap-2">
          <span className="text-md font-medium text-slate-600">{row.emailAddress}</span>
          {row.primary && <Badge text="Primarni" variant="info" height="small" />}
        </div>
      );
    },
  },
  {
    title: "Opis",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactEmailRow) => {
      return <div className="text-sm text-slate-900 truncate">{row.description}</div>;
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactEmailRow) => {
      return (
        <div onClick={(e) => handleDeleteClick(e, row.id)} className="flex justify-end items-center h-[30px]">
          <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
        </div>
      );
    },
  },
];
